export const REFERRAL_HERO_SOURCE_CAMPAIGN = 'referralHeroSourceCampaign';

export const setRHSourceCampaign = source => {
  if (!source) return;

  window.sessionStorage.setItem(REFERRAL_HERO_SOURCE_CAMPAIGN, source);
};

export const getRHSourceCampaign = () => {
  return window.sessionStorage.getItem(REFERRAL_HERO_SOURCE_CAMPAIGN);
};
